import { Box } from "@mui/material";
import { InfoSection } from "../../components/common/infoSection";
import type { Asset } from "../../types/deal";
import {
  dateFormatter,
  dateTimeFormatter,
  numberFormatter,
} from "../../utils/numberFormatter";
import ExtractedTenantsTable from "../tenant/ExtractedTenantTable";
import { AssetMap } from "../../components/common/maps";

interface AssetDetailSectionProps {
  asset: Asset;
  isEdit: boolean;
}

export const AssetDetail = ({ asset }: AssetDetailSectionProps) => {
  const dealObj = (asset as any).deal;
  const sectorObj = (asset as any).sector;
  const countryObj = (asset as any).country;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "10px",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <InfoSection
          title="Asset Details"
          items={[
            {
              label: "Asset name",
              value: asset.asset_name,
              link: `/assets/${asset.id}`,
            },
            {
              label: "Deal",
              value: dealObj?.deal_name ?? "-",
              link: dealObj?.id ? `/deals/${dealObj?.id}` : undefined,
            },
            { label: "Sector", value: sectorObj?.sector },
            { label: "Address 1", value: asset.address_1 },
            { label: "Address 2", value: asset.address_2 },
            { label: "City", value: asset.city },
            { label: "Country", value: countryObj?.nicename },
            { label: "Description", value: asset.description ?? "-" },
            {
              label: "Created At",
              value: dateTimeFormatter({ value: asset.created_at }),
            },
            {
              label: "Updated At",
              value: dateTimeFormatter({ value: asset.updated_at }),
            },
          ]}
        />
        <InfoSection
          title="Key Stats"
          items={[
            {
              label: "Acquisition Price",
              value: asset.acquisition_price ?? "-",
            },
            {
              label: "Acquisition Date",
              value: dateFormatter({ value: asset.acquisition_date }),
            },
            { label: "Valuation", value: asset.valuation_amount ?? "-" },
            {
              label: "Valuation Date",
              value: dateFormatter({ value: asset.valuation_date }),
            },
            { label: "Currency", value: asset.currency ?? "-" },
            { label: "Year Built", value: asset.year_built ?? "-" },
            { label: "Year Refurbished", value: asset.year_refurbished ?? "-" },
            { label: "No. of Buildings", value: asset.count_buildings ?? "-" },
            { label: "No. of Floors", value: asset.count_floors ?? "-" },
            { label: "No. of Units", value: asset.count_units ?? "-" },
            { label: "EPC Rating", value: asset.epc_rating ?? "-" },
          ]}
        />
        <InfoSection
          title="Tenancy Stats"
          items={[
            {
              label: "Total Area",
              value:
                numberFormatter({ value: asset.total_area }) +
                " " +
                asset.area_type,
            },
            { label: "WALT", value: asset.walt ?? "-" },
            { label: "WALB", value: asset.walb ?? "-" },
            { label: "Passing Rent", value: asset.passing_rent ?? "-" },
            { label: "Contracted Rent", value: asset.contracted_rent ?? "-" },
            {
              label: "Estimated Rental Value",
              value: asset.estimated_rental_value ?? "-",
            },
            { label: "NOI", value: asset.noi ?? "-" },
            { label: "Capex Total", value: asset.capex_total ?? "-" },
          ]}
        />
      </Box>
      <AssetMap
        assets={asset}
        accordions={undefined}
        showAssetNumbers={false}
        hideFullscreenButton={true}
      />

      <ExtractedTenantsTable assetId={asset.id ?? null} editMode={false} />
    </Box>
  );
};
